import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppConfig } from 'src/app/config-service/app.config';
import { TransactionListResModel } from '../../models/cardTransactionsResponse.model';
import { CardTransactionService } from '../../services/getCardTransactions.service';
import { IDate } from '../date-picker/models/Datepicker-date-models';

@Component({
  selector: 'app-card-detail',
  templateUrl: './card-detail.component.html',
  styleUrls: ['./card-detail.component.scss', '../../card-operations.component.css']
})
export class CardDetailComponent implements OnInit {
  @Input() modalInput!: string;

  cardDetailPickerminDate!: Date;
  cardDetailPickermaxDate!: Date;
  cardDetailSelectedDate!: string;
  cardTransactionResult:Array<TransactionListResModel> = [];

  dateSubmitted = false;

  isLoading = false;
  apiSettings = AppConfig.settings;
  public cardDetailTabGroupIndex:number = 0;

  constructor(
    private toastr: ToastrService,
    private translate: TranslateService,
    private restGetCardTransations: CardTransactionService
  ) {
      const currentMonth = new Date().getMonth();
      const currentDay = new Date().getDate();
      const currentYear = new Date().getFullYear();
      this.cardDetailPickermaxDate = new Date();
      if (currentMonth - 6 > 0) {
        this.cardDetailPickerminDate = new Date(
          currentYear,
          currentMonth - 6,
          currentDay
        );
      } else {
        this.cardDetailPickerminDate = new Date(
          currentYear - 1,
          11 + currentMonth - 6,
          currentDay
        );
      }
  
      this.cardDetailSelectedDate = '0';
  }

  ngOnInit(): void {
  }

  cardDetail_onClick() {
    this.dateSubmitted = true;
    if (this.cardDetailSelectedDate === '0') {
      this.toastr.error(
        this.translate.instant(
          'CARDOPERATIONS_CARD_DETAIL_DATENOTSELECTED_LABEL'
        )
      );
      return 0;
    }

    this.cardTransactionResult = [];
    this.isLoading = true;

    let alias = this.aliasReformatter(this.modalInput);

    return new Promise((resolve, reject) => {
      this.restGetCardTransations
        .getCardTransactionsResult(alias, this.cardDetailSelectedDate)
        .subscribe(
          (resp) => {
            this.isLoading = false;

            if (resp.result.hasOwnProperty('code') && resp.result.code === 0) {
              resp.transactionList.forEach((el) => {
                this.cardTransactionResult.push(el);
              });

              if (this.cardTransactionResult.length <= 0) {
                this.toastr.error(
                  this.translate.instant(
                    'CARDOPERATIONS_CARD_DETAIL_RESULTNOTFOUND_LABEL'
                  )
                );
              }
            } else {
              this.toastr.error(
                resp != null
                  ? resp.result.message
                  : this.translate.instant('DEFAULT_ERROR_MESSAGE')
              );
            }
          },
          (error:any) => {
            this.isLoading = false;
            this.toastr.error(
              error != null
                ? error
                : this.translate.instant('DEFAULT_ERROR_MESSAGE')
            );
            reject(error);
          }
        );
    });
  }

  aliasReformatter(aliasNo:any) {
    /*
      formatter(aliasNo) EXAMPLE:
      Entry = 33800-00002-6
      Output = 3380000002
    */
    const newAlias = aliasNo.split('-').join('');
    return newAlias.substring(0, 10);
  }

  cardDetail_DateChanged(event: IDate) {
    let month = event.month;
    let year = event.year

    if (month && year) {
      this.cardDetailSelectedDate = year + month;
    } else {
      this.cardDetailSelectedDate = '0';
    }
  }

}